export default {"src":"/_next/static/media/ios-button.33217f86.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};